export default __webpack_public_path__ + "static/media/1598.9f16b15e.png";